<template>
<div style="z-index: 1000">
    <van-overlay :show.sync="show" duration="0.2">
        <div class="wrapper">
            <div class="content">
                <van-image v-if="qrCode" class="qr-code" width="4rem" height="4rem" fit="contain" :src="qrCode"/>
                <span v-if="qrCode" class="qr-explain">扫一扫上面的二维码图案，加我微信</span>
                <p v-if="phone" :class="['phone', !qrCode && 'moreTop']">
                    <a :href="'tel:' + phone">电话：{{phone}}</a>
                </p>
                <span v-if="phone" class="phone-explain">资源开放，联系方式如上</span>
                <span v-if="cp_noMore" class="no-more">资源暂未开放，敬请期待</span>
                <div class="btn-close" @click="$emit('close')">知道了~</div>
            </div>
        </div>
    </van-overlay>
</div>
</template>

<script>
export default {
    name: "askMore",
    props: {
        show:{
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            phone: '',
            qrCode: '',
        }
    },
    computed: {
      cp_noMore() {
         return !this.phone && !this.qrCode;
      }
    },
    mounted() {
        this.phone = sessionStorage.getItem('phone') || '';
        let wxUrls = sessionStorage.getItem('wxUrls');
        if(wxUrls) {
            wxUrls = JSON.parse(wxUrls);
            if(wxUrls && wxUrls.length) {
                const index = Math.floor(Math.random() * wxUrls.length);
                this.qrCode = wxUrls[index];
            }
        }
    }
}
</script>

<style scoped lang="less">
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 90%;
    .content {
        width: 5.5rem;
        background-color: #fff;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .qr-code {
            margin-top: 0.3rem;
            padding-top: 0.3rem;
        }
        .qr-explain {
            font-size: 0.25rem;
            color: #999999;
            padding-top: 0.15rem;
        }
        .phone {
            color: #333;
            font-size: 0.35rem;
            a {
                color: #333;
            }
            padding-top: 0.15rem;
            &.moreTop {
                padding-top: 0.6rem;
            }
        }
        .phone-explain {
            font-size: 0.25rem;
            color: #999999;
            padding-top: 0.1rem;
        }
        .no-more {
            color: #333;
            font-size: 0.35rem;
            padding-top: 0.5rem;
            padding-bottom: 0.2rem;
        }
        .btn-close {
            color: #ffffff;
            font-size: 0.4rem;
            padding: 0.22rem 0.5rem;
            background-color: rgb(87, 142, 247);
            border-radius: 0.2rem;
            display: flex;
            align-items: center;
            margin-top: 0.3rem;
            margin-bottom: 0.5rem;
        }
    }
}
</style>